var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlatinum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "122.585%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "3qcajtlr2a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBF4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5DB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "122.585%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "femjwa2whb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBF4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5DB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "122.585%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "mp4bkpbmsc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBF4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5DB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "122.585%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "gdyear70vd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBF4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5DB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "122.585%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "o1xsnzqt6e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBF4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5DB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "122.585%",
    y1: "50%",
    x2: "0%",
    y2: "50%",
    id: "ttnvta4hef"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9EBF4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5DB",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .852)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "url(#3qcajtlr2a)",
    strokeWidth: 1.175,
    fill: "#FFF",
    x: 0.587,
    y: 0.587,
    width: 88.825,
    height: 88.825,
    rx: 4.7
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#femjwa2whb)",
    d: "m27.671 8.327-7.007 22.097L37.598 8.327z",
    transform: "translate(27.023 30.523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#mp4bkpbmsc)",
    d: "M5.459.51.079 6.94h9.145zM32.139.51l-3.766 6.43h9.145z",
    transform: "translate(27.023 30.523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#femjwa2whb)",
    d: "M9.927 8.327H0l16.933 22.097z",
    transform: "translate(27.023 30.523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#gdyear70vd)",
    d: "m20.48 0 6.534 6.506L30.824 0zM6.773 0l3.81 6.506L17.118 0z",
    transform: "translate(27.023 30.523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#o1xsnzqt6e)",
    d: "m11.388 8.327 7.41 23.37 7.412-23.37z",
    transform: "translate(27.023 30.523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#ttnvta4hef)",
    d: "m18.799.287-6.68 6.652h13.36z",
    transform: "translate(27.023 30.523)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinum);
export default __webpack_public_path__ + "static/media/platinum.827a4154e1fd389996e6a50025c35bdb.svg";
export { ForwardRef as ReactComponent };